// Shared category chip helpers so the Report page, Badge page, and (eventually) the OG image
// agree on labels and colour thresholds.

export const SHORT_CATEGORY_LABELS = {
  design: "Design",
  placement: "Placement",
  cta: "CTA",
  tracking: "Tracking",
  mobile_ux: "Mobile UX",
  security: "Security",
};

export function shortLabelFor(key, fallbackLabels = {}) {
  return SHORT_CATEGORY_LABELS[key] || fallbackLabels[key] || key;
}

// Kept in sync with backend og_image._score_color:
//   >= 60 -> lime, >= 40 -> amber, < 40 -> red
export function scoreColor(score) {
  if (score >= 60) return "#C6F84C";
  if (score >= 40) return "#F59E0B";
  return "#EF4444";
}

// Kept in sync with backend og_image.LEVEL_COLORS
export function levelColor(level) {
  if (level === "Best-in-Class") return "#34D399";
  if (level === "Competent") return "#C6F84C";
  if (level === "Developing") return "#F59E0B";
  if (level === "At Risk") return "#EF4444";
  return "#C6F84C";
}

export function roundScore(value) {
  // Match backend og_image (floor + 0.5) and page display.
  return Math.round(value);
}
